import { MutationTree } from 'vuex';
import { EBetaFlagMutation } from '@/beta-flag/store/beta-flag.constants';
import { IBetaFlagState } from '@/beta-flag/store/beta-flag.types';

export const mutations: MutationTree<IBetaFlagState> = {
  [EBetaFlagMutation.SetFlags](
    state: IBetaFlagState,
    flags: {
      v3: number;
      contentLinkBlock: number;
      videoBlock: number;
      editorBlock: number;
      contentLibrary: number;
      dealscore: number;
      editAfterSent: number;
      editorCustomMergeTag: number;
    }
  ) {
    state.flags = { ...flags };
  },
  [EBetaFlagMutation.SetDismissedBetaExpires](state: IBetaFlagState, date: string) {
    state.dismissedBetaExpires = date;
  },
  [EBetaFlagMutation.SetContentLibraryFlag](state: IBetaFlagState, flag: number) {
    state.flags.contentLibrary = flag;
  },
  [EBetaFlagMutation.SetDealscoreFlag](state: IBetaFlagState, flag: number) {
    state.flags.dealscore = flag;
  },
};
